/*
 * -----------------------------------------------------------------------
 *  <copyright file="pagination/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2022 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React, { useEffect, useRef } from 'react';
import './styles.scss';
import { NumericTextBox, NumericTextBoxChangeEvent, NumericTextBoxHandle } from '@progress/kendo-react-inputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IPaginationProps } from './pagination.interface';
import { setAttribute } from '@utils/automation-test-helpers';

const Pagination = ({ currentPage, totalPages, onChange }: IPaginationProps) => {
    const handleInputChange = (e: NumericTextBoxChangeEvent) => {
        onChange(e.value || 1);
    };

    const ref = useRef<NumericTextBoxHandle>(null);

    useEffect(() => setAttribute(ref, 'data-testid', 'pagination-input'));

    return (
        <div className="pagination">
            <button
                type="button"
                className="pagination__nav"
                disabled={currentPage === 1}
                onClick={() => onChange(currentPage - 1)}
                data-testid="pagination-previous"
            >
                <FontAwesomeIcon icon={['fal', 'chevron-left']} />
            </button>
            <NumericTextBox
                className="pagination__input"
                value={currentPage}
                rounded={null}
                onChange={handleInputChange}
                min={1}
                max={totalPages}
                spinners={false}
                ref={ref}
            />
            <span className="pagination__splitter">/</span>
            <span className="pagination__total">{totalPages}</span>
            <button
                type="button"
                className="pagination__nav"
                disabled={currentPage >= totalPages}
                onClick={() => onChange(currentPage + 1)}
                data-testid="pagination-next"
            >
                <FontAwesomeIcon icon={['fal', 'chevron-right']} />
            </button>
        </div>
    );
};

export default Pagination;
